export default function unfavoriteModel(state, action) {
  const { id, controllerModel } = action
  const key = controllerModel ? 'favoriteDoorControllerModels' : 'favoriteModels'

  return Object.assign({}, state, {
    [key]: state[key].filter(modelId => modelId !== id)
  })
}



// WEBPACK FOOTER //
// ./src/reducers/unfavoriteModel.js